import { isNotificationsCleared } from "../../../../domain/notification/model/notificationsCleared";
const storageNotificationsClear = ({ storage }) => async (aggregateRoot) => {
    const notificationsCleared = aggregateRoot.domainEvents.find(isNotificationsCleared);
    if (!notificationsCleared) {
        return;
    }
    await storage.clear();
};
export { storageNotificationsClear };
